export default {
  forgot_password: {
    title: 'Reset password',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Forgot password',
    password_reset_text: 'Type in your email address. You will receive a confirmation email to reset your password.',
    submit: 'Send',
    mail_address: 'Fill in email address',
    input_label: '@:settings.user.email',
  },
}
